import React, { Component } from "react";
import Header from "./Header";
import Jumbotron from "./Jumbotron";
import Summary from "./Summary";
import ClientProjects from "./Projects/ClientProjects";
import SideProjects from "./Projects/SideProjects";
import Skills from "./Skills";
import Footer from "./Footer";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Jumbotron />
        <div className="headline">
          <Summary />
          <ClientProjects />
          <SideProjects />
        </div>
        <Skills />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/component/App.js